<template>
  <div class="login-by-phone">
    <div class="reset-password">
      <el-form ref="form" :rules="rules" :model="form">
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="form.password"
            placeholder="请输入新密码"
            auto-complete="new-password"
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="username">
          <el-input
            AUTOCOMPLETE="off"
            v-model="form.username"
            placeholder="请输入手机号或者邮箱地址"
            auto-complete="new-password"
          >
          </el-input>
        </el-form-item>

        <el-form-item class="form-item" prop="code">
          <el-input
            v-model="form.code"
            placeholder="请输入验证码"
            auto-complete="new-password"
          >
            <div
              class="verification-class"
              v-if="isShow"
              @click="verification"
              slot="append"
            >
              获取验证码
            </div>
            <div v-else slot="append">{{ count }}秒后再获取</div>
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit('form')"
            class="loginbutton"
            >提&nbsp;交</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
  <script>
import LoginTitle from "./LoginTitle.vue";
import CountDown from "../common/CountDown.vue";
import Vcode from "vue-puzzle-vcode";
import { mapGetters } from "vuex";
export default {
  components: {
    LoginTitle,
    CountDown,
    Vcode,
  },
  data() {
    var validatorUsername = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("账号不能为空"));
      } else if (
        !(
          /^1\d{10}$/.test(value) ||
          /^([\.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/.test(value)
        )
      ) {
        callback(new Error("账号格式错误"));
      } else {
        callback();
      }
    };
    return {
      form: {
        username: "",
        password: "",
        code: "",
      },
      rules: {
        username: [
          { required: true, validator: validatorUsername, trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" },
        { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      isShow: true,
      count: 0,
      visShow: false,
      sendType: 1,
    };
  },
  methods: {
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.resetPassword();
        } else {
          return false;
        }
      });
    },
    onSuccess(msg) {
      this.visShow = false;
      //可以在此加上axios或其他代码
    },
    onClose() {
      this.visShow = false;
    },
    verification() {
      this.sendCode();
    },
    countdown() {
      this.isShow = false; //倒计时
      // this.visShow = true;
      this.count = 60; //赋值60秒
      var times = setInterval(() => {
        this.count--; //递减
        if (this.count <= 0) {
          // <=0 变成获取按钮
          this.isShow = true;
          clearInterval(times);
        }
      }, 1000); //1000毫秒后执行
    },
    //发送验证码
    sendCode() {
      let info = {};
      var reg_tel3 = /^1\d{10}$/;

      if (reg_tel3.test(this.form.username)) {
        info.phone = this.form.username;
        if (this.UserPhone != this.form.username ) {
          this.$FUnitls.showInfo("该手机号未绑定", "info");
          return false;
        }
        this.sendType = 1;
        //手机号
        this.$api.user.sendCode(info).then((res) => {
          if (res.data.errno == 0) {
            this.$FUnitls.showInfo("发送成功", "info");
            this.countdown();
          } else {
            this.$FUnitls.showInfo(res.data.msg, "info");
          }
        });
      } else if (
        /^([\.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/.test(
          this.form.username
        )
      ) {
        info.mail = this.form.username;
        if (this.UserMail != this.form.username) {
          this.$FUnitls.showInfo("该邮箱未绑定", "info");
          return false;
        }
        this.sendType = 2;
        //邮箱
        this.$api.user.sendMailCode(info).then((res) => {
          if (res.data.errno == 0) {
            this.$FUnitls.showInfo("发送成功", "info");
            this.countdown();
          } else {
            this.$FUnitls.showInfo(res.data.msg, "info");
          }
        });
      } else {
        this.$FUnitls.showInfo("请输入正确的账号", "info");
      }
    },

    resetPassword() {
      let info = {};
      info.type = this.sendType;

      if (info.type == 1) {
        info.phone = this.form.username;
      } else {
        info.mail = this.form.username;
      }

      info.password = this.form.password;
      info.code = this.form.code;

      this.$api.user.passwordUpdate(info).then((res) => {
        if (res.data.errno == 0) {
          this.$FUnitls.showInfo("重置密码成功", "success");
          //清空数据
          this.form.password = "";
          this.form.username = "";
          this.form.code = "";
          this.form.isShow = true;
        } else {
          this.$FUnitls.showInfo(res.data.errmsg, "error");
        }
      });
    },
  },

  computed: {
    ...mapGetters(["UserPhone", "UserMail"]),
  },
  mounted() {},
};
</script>
  <!--声明语言，并且添加scoped-->
  <style scoped>
.reset-password {
  width: 670px;
}

.ruleurlbox {
  color: #666666;
  font-size: 14px;
  margin-left: 5px;
}
.ruleurlbox a {
  color: #0464cd;
}
.icon-shouji {
  color: #0464cd;
}
.form-item {
  position: relative;
  margin-bottom: 42px;
}
.verification-class {
  cursor: pointer;
}
.login-by-phone {
  margin-top: 25px;
}
.login-by-phone >>> input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #c7c6c6 inset !important;
  -webkit-text-fill-color: #ededed !important;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
  background-color: transparent;
  background-image: none;
  transition: background-color 50000s ease-in-out 0s;
  -webkit-text-fill-color: #666 !important;
}

.login-by-phone >>> .el-input--prefix .el-input__inner {
  color: #666 !important;
  font-size: 16px;
  padding-left: 50px;
  border: none;
  border-bottom: 1px solid #e6e6e6;
  height: 54px;
  line-height: 54px;
  border-radius: 0;
}
.login-by-phone >>> .el-input--prefix .el-input__inner:-webkit-autofill {
  color: #666 !important;
}

.register-line {
  text-align: center;
  font-size: 16px;
  color: #666;
}
.register-line .register {
  color: #0464cd;
}

.login-by-phone >>> .el-form-item.is-error .el-input__inner,
.el-form-item.is-error .el-input__inner:focus {
  border: none;
  border-bottom: 1px solid #e6e6e6;
}

.login-by-phone >>> .el-input--prefix .iconfont.icon-youxiang1 {
  font-size: 26px;
}
.login-by-phone >>> .el-input-group__append,
.login-by-phone >>> .el-input-group__prepend {
  border: none;
  border-bottom: 1px solid #e6e6e6;
  background-color: #fff;
  color: #0464cd;
}
.login-by-phone >>> .el-input__prefix .iconfont.icon-renzhengguanli {
  font-size: 26px;
}
.login-by-phone >>> .el-input__prefix .iconfont.icon-suo {
  font-size: 26px;
}
.login-by-phone >>> .el-input__prefix {
  padding-top: 2px;
}
.login-by-phone >>> .el-input__prefix .iconfont {
  color: #0464cd;
  font-size: 20px;
}

.login-by-phone >>> .loginbutton {
  font-size: 16px;
  padding: 8px 28px;
}

.login-by-phone >>> .el-checkbox__label {
  color: #fff;
}
.login-by-phone >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #fff;
}
.login-by-phone >>> .el-button {
  border-radius: 26px;
}
.forget-password {
  float: right;
  font-size: 14px;
}
.forget-password a {
  color: #0177f0;
}
.login-by-phone >>> .el-checkbox__inner {
  border-radius: 7px !important;
}
.login-by-phone >>> .el-input__inner {
  border: none;
  border-bottom: 1px solid #e6e6e6 !important;
  border-radius: 0;
  font-size: 16px;
  padding: 0;
}
.login-by-phone >>> .el-form-item__content {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/user/UserResetPasswordShow.vue